import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { AuthService } from 'src/app/core/services/AuthService';
import { AuthSessionService } from 'src/app/core/services/AuthSessionService';
import { BrandingService } from 'src/app/core/services/branding.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-form-mfa',
  templateUrl: './form-mfa.component.html',
  styleUrls: ['./form-mfa.component.scss']
})
export class FormMFAComponent implements OnInit  {

  @ViewChildren('codeInput')
  codeInputs!: QueryList<ElementRef<HTMLInputElement>>;

  mfaForm: FormGroup;

  loading = false;
  returnUrl = "/dashboard/default";
  returnUrlProfile = "/perfil/perfil";
  logoUrl: string | null = null;


  codeControls = [
    'digit1',
    'digit2',
    'digit3',
    'digit4',
    'digit5',
    'digit6'
  ];

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,    
    private authSessionService: AuthSessionService,
    private brandingService: BrandingService , 
    private router: Router
  ) {

    this.mfaForm = this.fb.group({
      digit1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit4: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit5: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit6: ['', [Validators.required, Validators.pattern(/^\d$/)]]
    });
  }

  ngOnInit() {
    this.logoUrl =
      this.brandingService.getLogoUrl() ||
      "assets/images/dashboard/logo-oscuro.png";

    
    

    this.brandingService.settings$.subscribe(() => {
      this.logoUrl = this.brandingService.getLogoUrl();
    });
  }

  onCodeInput(event: Event, index: number): void {

    const input = event.target as HTMLInputElement;

    input.value = input.value.replace(/\D/g, '');

    this.mfaForm
      .get(this.codeControls[index])
      ?.setValue(input.value);

    if (input.value && index < 5) {
      this.codeInputs
        .get(index + 1)
        ?.nativeElement
        .focus();
    }
  }

  
  goBack(): void {
  this.authService.forceLocalLogout(true, 'manual');
  this.router.navigate(['/auth/login']);
}

  onCodeKeyDown(
    event: KeyboardEvent,
    index: number
  ): void {

    const input = event.target as HTMLInputElement;

    if (
      event.key === 'Backspace' &&
      !input.value &&
      index > 0
    ) {

      this.codeInputs
        .get(index - 1)
        ?.nativeElement
        .focus();
    }

  }

  onPaste(event: ClipboardEvent): void {

    event.preventDefault();

    const pasted = event.clipboardData
      ?.getData('text')
      .replace(/\D/g, '')
      .slice(0, 6);

    if (!pasted) {
      return;
    }

    pasted.split('').forEach((digit, index) => {

      const controlName = this.codeControls[index];

      this.mfaForm
        .get(controlName)
        ?.setValue(digit);

    });

    setTimeout(() => {

      const position = Math.min(pasted.length, 5);

      this.codeInputs
        .get(position)
        ?.nativeElement
        .focus();

    });

  }

  onLogoError(event: any) {
    if (!event.target.src.includes("logo-oscuro.png")) {
      event.target.src = "assets/images/dashboard/logo-claro.png";
    }
  }

  async confirmMfa(): Promise<void> {

  if (this.mfaForm.invalid || this.loading) {
    this.mfaForm.markAllAsTouched();
    return;
  }

  const code = this.codeControls
    .map(control =>
      this.mfaForm.get(control)?.value
    )
    .join('');

  if (!/^\d{6}$/.test(code)) {
    return;
  }

  try {

    this.loading = true;

    const loginResult: any =
      await this.authService.loginMFACode(code);

    if (!loginResult?.access_token?.trim()) {
      throw new Error(
        'No se recibió access_token después de validar MFA'
      );
    }

    await this.authSessionService.completeLogin(
      loginResult.access_token
    );

  } catch (error) {

    console.error(
      'Código MFA inválido:',
      error
    );

  } finally {

    this.loading = false;
  }

}

  useRecoveryCode(): void {

    console.log(
      'Usar código de recuperación'
    );

  }

}